"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AlertDialog;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function AlertDialog(_ref) {
  let {
    title = undefined,
    message,
    onClose
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    onClose: onClose,
    open: true
  }, title && /*#__PURE__*/_react.default.createElement(_DialogTitle.default, null, title), /*#__PURE__*/_react.default.createElement(_DialogContent.default, {
    dividers: true
  }, message), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: onClose,
    color: "primary"
  }, "Close")));
}
AlertDialog.defaultProps = {
  title: undefined
};
AlertDialog.propTypes = {
  title: _propTypes.default.string,
  message: _propTypes.default.string.isRequired,
  onClose: _propTypes.default.func.isRequired
};